import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MobileSelectFieldResult } from '@wdx/portal/api-models';
import { ContextualDataContext } from '@wdx/shared/infrastructure/form-framework';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { SelectUrlSegment } from './select-url-segment';

interface ContextualSelectBody {
    lookups: unknown[];
    context?: ContextualDataContext[];
}

@Injectable({ providedIn: 'root' })
export class SelectApiService extends BaseApiService {
    getSelect(selectSource: string): Observable<MobileSelectFieldResult[]> {
        const [selectKey, params] = selectSource.split('?');
        return this._get<MobileSelectFieldResult[]>(
            `${SelectUrlSegment.Select}/${selectKey.toLowerCase()}`,
            params ? { params: new HttpParams({ fromString: params }) } : {},
        );
    }

    getContextualSelect(
        source: string,
        lookups: unknown[],
        context?: ContextualDataContext[],
    ): Observable<MobileSelectFieldResult[]> {
        let body: ContextualSelectBody = { lookups };
        if (context) {
            body = { lookups, context };
        }
        return this.post<MobileSelectFieldResult[], ContextualSelectBody>(
            `${SelectUrlSegment.Select}/${source.toLowerCase()}`,
            body,
        );
    }
}
